import { Http } from '../../core/http';
import { globalHeaders } from '../../utils/http';
import {ParsingError, ServerError} from "../../core/errors";

export type BatchReceiverRequest = {
  requesterId: string;
  lockoutLevel: 'SESSION' | 'PASSWORD' | 'ACCESS';
  issueId?: string;
  consumerIds: string[];
};

export type BatchReceiverResponse = {
  errors: string[];
  invalidIds: string[];
  failedToSend?: string[];
}

export async function batchReceiver({
  requesterId, lockoutLevel, issueId, consumerIds
}: BatchReceiverRequest): Promise<BatchReceiverResponse> {
  const batchUrl = process.env.REACT_APP_BATCH_URL || '/bartender/batch_receiver/v1';
  const request = await new Http(batchUrl, {
    method: 'POST', mode: 'cors', //'no-cors'
    body: JSON.stringify({
      requesterId,
      lockoutLevel,
      issueId,
      consumerIds
    })
  }, globalHeaders).exec();

  switch (request.status) {
    case 202:
      return {
        errors: [],
        invalidIds: []
      };
    case 400:
      return await request.json<BatchReceiverResponse>();
    default:
      const response = await request.json();

      if (!Array.isArray(response)) {
        throw new ParsingError(JSON.stringify(response), batchUrl);
      }

      const [{ message, keyword }] = response;

      throw new ServerError(
          { error_id: '', errors: [{ message, code: keyword }] },
          request.status as number,
          '/bartender/batch_receiver/v1'
      );
  }
}

